import { useCallback } from 'react';
import { MAP_TYPES } from 'common/utils/Map/constants';

import { useMapContext } from 'entities/map';
import { setMapType } from '../../index';

const useOnClick = (setStateMapType: setMapType) => {
  const { setMapType } = useMapContext();

  const onClick = useCallback(() => {
    setMapType(MAP_TYPES.HYBRID);
    setStateMapType(MAP_TYPES.HYBRID);
  }, [
    setMapType,
    setStateMapType
  ]);

  return onClick;
};

export default useOnClick;
